import React from "react";
import PainelOperadoras from "./painelOperadoras";
import EstadoRequisicao from "../componentes/EstadoRequisicao";
import { useFiltroAba } from "../contexto/filtroHome";
import { useRequisicao } from "../hooks/useRequisicao";
import TabelaTransacoes from "../componentes/tabelaTransacoes";
import { FiltroHome, buscarPainel } from "../../../../services/home";

const Vendas = () => {
  const filtro = useFiltroAba("VENDA");
  const { dados, carregando, erro, recarregar } = useRequisicao(
    () => buscarPainel("VENDA", filtro as FiltroHome),
    [filtro],
    Boolean(filtro)
  );

  return (
    <EstadoRequisicao carregando={carregando || !filtro} erro={erro} vazio={!!dados && dados.operadoras.length === 0} onRecarregar={recarregar}>
      {dados && (
        <PainelOperadoras
          titulo="Vendas por operadora"
          operadoras={dados.operadoras}
          indicadores={dados.indicadores}
          detalhes={<TabelaTransacoes tipo="VENDA" filtro={filtro as FiltroHome} />}
        />
      )}
    </EstadoRequisicao>
  );
};

export default Vendas;
